module.exports = __webpack_public_path__ + "media/images/mailers/welcome_email/closed_lock_with_key-464ba96c6ef6ddb32e45e9029f38ac94.png";